import * as types from "../types/printers"

const initialState = []

const printerDisplaysReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PRINTERS:
      return [...action.printers]
    case types.ADD_PRINTER:
      return [...state, action.newPrinter]
    case types.ADD_POS_PRINTER:
      return [...state, action.posPrinter]
    case types.EDIT_PRINTER:
      return state.map(p =>
        p._id === action.printerId
          ? { ...p, ...action.data }
          : p
      )
    case types.DELETE_PRINTER:
      return state.filter(p => p._id !== action.printerId)
    default:
      return state
  }
}

export default printerDisplaysReducer